import {
    CREATE_ACCESSORIS_MASTER_REQUEST,
    CREATE_ACCESSORIS_MASTER_SUCCESS,
    CREATE_ACCESSORIS_MASTER_FAILURE,
    DELETE_ACCESSORIS_MASTER_REQUEST,
    DELETE_ACCESSORIS_MASTER_SUCCESS,
    DELETE_ACCESSORIS_MASTER_FAILURE,
    FETCH_SINGLE_ACCESSORIS_MASTER_REQUEST,
    FETCH_SINGLE_ACCESSORIS_MASTER_SUCCESS,
    FETCH_SINGLE_ACCESSORIS_MASTER_FAILURE,
    FETCH_ACCESSORIS_MASTER_REQUEST,
    FETCH_ACCESSORIS_MASTER_SUCCESS,
    FETCH_ACCESSORIS_MASTER_FAILURE,
    UPDATE_ACCESSORIS_MASTER_REQUEST,
    UPDATE_ACCESSORIS_MASTER_SUCCESS,
    UPDATE_ACCESSORIS_MASTER_FAILURE,
    RESET_ACCESSORIS_MASTER_INFO,
    CREATE_ACCESSORIS_MASTER_FORM,
    UPDATE_ACCESSORIS_MASTER_FORM,
    FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_SUCCESS,
    FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_REQUEST,
    FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_FAILURE,
    FETCH_ACCESSORIS_MASTER_FOR_SIZE_REQUEST,
    FETCH_ACCESSORIS_MASTER_FOR_SIZE_SUCCESS,
    FETCH_ACCESSORIS_MASTER_FOR_SIZE_FAILURE
} from './accessoriesMaster.actionsType';

export const ACCESSORIS_MASTER = 'accessoriesMaster';

let initialState = {
    loading: false,
    accessoriesMaster: [],
    accessoriesType: [],
    accessoriesBrand: [],
    accessoriesCategory: [],
    accessoriesSubCategory: [],
    accessoriesIiuom: [],
    accessoriesSize: [],
    accessoriesSource: [],
    accessoriesMasterForSizes: [],
    sizeOption: [],
    accessoriesMasterform: {},
    errorMessage: ''
};

export let accessoriesMasterReducer = (state = initialState, action) => {
    let { type, payload, propertyId, updatePayload } = action;

    switch (type) {
        case FETCH_ACCESSORIS_MASTER_REQUEST:
        case CREATE_ACCESSORIS_MASTER_REQUEST:
        case UPDATE_ACCESSORIS_MASTER_REQUEST:
        case FETCH_SINGLE_ACCESSORIS_MASTER_REQUEST:
        case FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_REQUEST:
        case DELETE_ACCESSORIS_MASTER_REQUEST:
        case FETCH_ACCESSORIS_MASTER_FOR_SIZE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIS_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesMaster: updatePayload
            };
        case FETCH_ACCESSORIS_MASTER_FOR_SIZE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesMasterForSizes: updatePayload
            };
        case FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_SUCCESS:
            if (payload == 38) {
                return {
                    ...state,
                    loading: false,
                    accessoriesType: updatePayload
                };
            } else if (payload == 44) {
                return {
                    ...state,
                    loading: false,
                    accessoriesCategory: updatePayload
                };
            } else if (payload == 45) {
                return {
                    ...state,
                    loading: false,
                    accessoriesSubCategory: updatePayload
                };
            } else if (payload == 12) {
                return {
                    ...state,
                    loading: false,
                    accessoriesBrand: updatePayload
                };
            } else if (payload == 47) {
                return {
                    ...state,
                    loading: false,
                    accessoriesSize: updatePayload
                };
            } else if (payload == 46) {
                return {
                    ...state,
                    loading: false,
                    accessoriesSource: updatePayload
                };
            } else if (payload == 81) {
                return {
                    ...state,
                    loading: false,
                    sizeOption: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_ACCESSORIS_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesMasterform: {}
            };
        case UPDATE_ACCESSORIS_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesMasterform: {}
            };
        case FETCH_SINGLE_ACCESSORIS_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesMasterform: updatePayload
            };
        case DELETE_ACCESSORIS_MASTER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case RESET_ACCESSORIS_MASTER_INFO:
            return {
                ...state,
                accessoriesMasterform: {}
            };
        case CREATE_ACCESSORIS_MASTER_FORM:
        case UPDATE_ACCESSORIS_MASTER_FORM:
            return {
                ...state,
                loading: false,
                accessoriesMasterform: {
                    ...state.accessoriesMasterform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_ACCESSORIS_MASTER_FAILURE:
        case CREATE_ACCESSORIS_MASTER_FAILURE:
        case UPDATE_ACCESSORIS_MASTER_FAILURE:
        case FETCH_SINGLE_ACCESSORIS_MASTER_FAILURE:
        case DELETE_ACCESSORIS_MASTER_FAILURE:
        case FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_FAILURE:
        case FETCH_ACCESSORIS_MASTER_FOR_SIZE_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
